import { render } from "./S311443Legal.vue?vue&type=template&id=140a8780"
const script = {}
script.render = render

export default script